// extracted by mini-css-extract-plugin
export default {"option":"styles_option__RNczL"};